import BrandsTableContainer from "./BrandsTableContainer";
export default BrandsTableContainer;
